// 定义顶部菜单按钮1
const topButton1 = {
  type: 2,
  title: '交易记录',
  jumpUrl: 'https://quickpass.meituan.com/resource/unionpay/index.html#/bill',
  icon: '',
};

// 定义顶部菜单按钮2
const topButton2 = {
  type: 6,
  title: '公交还款',
  jumpUrl: 'https://quickpass.meituan.com/resource/traffic/payoff.html?entry=qrcode',
  icon: '',
};

// 导出顶部菜单按钮数组
export const pageTopButtons = [topButton1, topButton2];

// 定义底部按钮
const bottomButton = {
  type: 5,
  title: '扫码支付',
  jumpUrl: 'imeituan://www.meituan.com/scanQRCode',
  icon: 'http://p0.meituan.net/scarlett/9c7fcd97a2fdecb74e1af6273553198b704.png',
};

// 导出底部按钮数组
export const pageBottomButtons = [bottomButton];

// 导出RSA公钥
export const RSAPublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwGQ3novoB0AimqKNy+FowNDMnoGllVxdUCh23fcqNATn7g1RrYhPe0OQ1KZtLaTlbMfAf67F/MwHKEHQTl9bS3Om8xGecmkDqbC/iK1pfgS6JlAEB30bT+0A17ZEDnFB/nIshiAahm3ophMyS11zPO3xCnQcNqLXSbumMhY5gvPSEse2a1gUfjnhX99wZ4s4nRnsBK64UojLgQbxOWC9HOUI4K5sfPmuo8Ex8+s+PZVaqrdYJztg173IS1kpS2RBhfH+WQ8nUUOtKJs9Ddz2VYAlOEMpmma2vsi/Tq9tqRRr5QpFrjE7WEFN5OsDicznZfU5E2tDz1Y7+9QsmAkyDQIDAQAB
-----END PUBLIC KEY-----`;
